module.exports = __webpack_public_path__ + "static/img/150.9ad38ff6.png";